import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    Signal,
} from '@angular/core';
import { MdsButtonComponent, MdsCheckboxComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Caregiver } from '@models/patient';
import { BookableCaregiver, CheckboxFormGroup } from '../../form-groups/travel-request-card.formgroup';

@Component({
    selector: 'medpace-caregiver-checkbox-option-view',
    imports: [MdsCheckboxComponent, MdsButtonComponent],
    templateUrl: './caregiver-checkbox-option-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaregiverCheckboxOptionViewComponent {
    public readonly formGroup: InputSignal<CheckboxFormGroup<BookableCaregiver | null>> = input.required();
    public readonly isPrimary: InputSignal<boolean> = input(false);

    public readonly bookViaGetThereForCaregiver: OutputEmitterRef<Caregiver> = output();

    public readonly label: Signal<string> = computed(() => {
        const caregiverPrefix = this.isPrimary() ? 'Primary Caregiver' : 'Caregiver';
        const caregiver = this.formGroup().getRawValue().value?.caregiver;
        const caregiverFullName = caregiver
            ? [caregiver.firstName, caregiver.middleName, caregiver.lastName].filter((name) => !!name).join(' ')
            : '';

        return caregiverPrefix + ' ' + caregiverFullName;
    });

    public readonly showBookButton: Signal<boolean> = computed(() => this.formGroup().value.value?.bookable ?? false);
}
